// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"e6b13baa","986":"c413c189"}[chunkId] + ".chunk.js";
};